import React from 'react';
import Spacer from '../../components/Spacer';
import { Divider, Skeleton } from 'day8-ui';
var StartBookingSkeleton = function () {
    return (React.createElement("div", { className: 'dui-container dui-mx-auto', role: "status", "aria-live": "polite", "aria-label": "Loading content" },
        React.createElement(Spacer, null),
        React.createElement(Skeleton, { className: 'dui-w-[68px] dui-h-[28px]' }),
        React.createElement(Spacer, null),
        React.createElement(Divider, null),
        React.createElement(Spacer, null),
        React.createElement("div", { className: "dui-w-full dui-flex dui-flex-col lg:dui-flex-row dui-gap-8 lg:dui-gap-24" },
            React.createElement("div", { className: 'dui-w-full lg:dui-w-3/5' },
                React.createElement(Skeleton, { className: 'dui-w-[250px] dui-h-[32px] dui-mb-4' }),
                React.createElement(Skeleton, { className: 'dui-w-full dui-h-[500px]' })),
            React.createElement("div", { className: 'dui-w-full lg:dui-w-2/5' },
                React.createElement(Skeleton, { className: 'dui-w-full dui-h-[1000px]' })))));
};
export default StartBookingSkeleton;
